module.exports = __webpack_public_path__ + "img/England.16028adf.png";